// Configuración centralizada de estados y colores para badges
// Basado en la paleta de colores especificada

export const SALE_STATUS_CONFIG = {
  // Primary
  created: {
    backgroundColor: 'var(--rg-color-primary-lighter)',
    color: 'var(--rg-color-primary-active)',
    textColor: 'var(--rg-color-primary-active)',
    label: 'Creada',
    class: 'badge-custom-created'
  },
  
  // Warning
  pending_docs: {
    backgroundColor: 'var(--rg-color-warning-lighter)',
    color: 'var(--rg-color-warning-active)',
    textColor: 'var(--rg-color-warning-active)',
    label: 'Pendiente de Documentación',
    class: 'badge-custom-pending-docs'
  },
  pending_verification: {
    backgroundColor: 'var(--rg-color-warning-lighter)',
    color: 'var(--rg-color-warning-active)',
    textColor: 'var(--rg-color-warning-active)',
    label: 'Pendiente de Verificación',
    class: 'badge-custom-pending-verification'
  },

  // Estado intermedio antes de la aprobación
  pre_approved: {
    backgroundColor: 'var(--rg-color-primary-lighter)',
    color: 'var(--rg-color-primary-active)',
    textColor: 'var(--rg-color-primary-active)',
    label: 'Pre-aprobada',
    class: 'badge-custom-pre-approved'
  },

  observed: {
    backgroundColor: 'var(--rg-color-primary-lighter)',
    color: 'var(--rg-color-primary-active)',
    textColor: 'var(--rg-color-primary-active)',
    label: 'Observada',
    class: 'badge-custom-observed'
  },

  invoice_required: {
    backgroundColor: 'var(--rg-color-warning-lighter)',
    color: 'var(--rg-color-warning-active)',
    textColor: 'var(--rg-color-warning-active)',
    label: 'Subir Factura',
    class: 'badge-custom-invoice-required'
  },

  invoice_under_review: {
    backgroundColor: 'var(--rg-color-info-lighter)',
    color: 'var(--rg-color-info-active)',
    textColor: 'var(--rg-color-info-active)',
    label: 'Verificando Factura',
    class: 'badge-custom-invoice-under-review'
  },

  pending_settlement: {
    backgroundColor: 'var(--rg-color-info-lighter)',
    color: 'var(--rg-color-info-active)',
    textColor: 'var(--rg-color-info-active)',
    label: 'Pendiente de Liquidación',
    class: 'badge-custom-pending-settlement'
  },
  
  // Success (internal) / approved (UI - Creditech)
  approved: {
    backgroundColor: 'var(--rg-color-success-lighter)',
    color: 'var(--rg-color-success-active)',
    textColor: 'var(--rg-color-success-active)',
    label: 'Aprobada',
    class: 'badge-custom-approved'
  },
  verified: {
    backgroundColor: 'var(--rg-color-success-lighter)',
    color: 'var(--rg-color-success-active)',
    textColor: 'var(--rg-color-success-active)',
    label: 'Verificada',
    class: 'badge-custom-verified'
  },
  liquidated: {
    backgroundColor: 'var(--rg-color-info-lighter)',
    color: 'var(--rg-color-info-active)',
    textColor: 'var(--rg-color-info-active)',
    label: 'Liquidada',
    class: 'badge-custom-liquidated'
  },
  
  // Info
  paid: {
    backgroundColor: 'var(--rg-color-info-lighter)',
    color: 'var(--rg-color-info-active)',
    textColor: 'var(--rg-color-info-active)',
    label: 'Pagada',
    class: 'badge-custom-paid'
  },
  
  // Danger
  rejected: {
    backgroundColor: 'var(--rg-color-danger-lighter)',
    color: 'var(--rg-color-danger-active)',
    textColor: 'var(--rg-color-danger-active)',
    label: 'Rechazada',
    class: 'badge-custom-rejected'
  },
  
  // Secondary
  cancelled: {
    backgroundColor: 'var(--rg-color-secondary-lighter)',
    color: 'var(--rg-color-secondary-active)',
    textColor: 'var(--rg-color-secondary-active)',
    label: 'Cancelada',
    class: 'badge-custom-cancelled'
  },
  annulled: {
    backgroundColor: 'var(--rg-color-secondary-lighter)',
    color: 'var(--rg-color-secondary-active)',
    textColor: 'var(--rg-color-secondary-active)',
    label: 'Anulada',
    class: 'badge-custom-annulled'
  }
};

// Estados para cobros (mantener compatibilidad)
export const COLLECTION_STATUSES = {
  pending: { 
    label: 'Pendiente', 
    class: 'badge-custom-pending',
    backgroundColor: 'var(--rg-color-warning-lighter)',
    textColor: 'var(--rg-color-warning-active)'
  },
  processed: { 
    label: 'Procesado', 
    class: 'badge-custom-processed',
    backgroundColor: 'var(--rg-color-success-lighter)',
    textColor: 'var(--rg-color-success-active)'
  },
  rejected: { 
    label: 'Rechazado', 
    class: 'badge-custom-rejected',
    backgroundColor: 'var(--rg-color-danger-lighter)',
    textColor: 'var(--rg-color-danger-active)'
  }
};

// Función helper para obtener la clase CSS de un estado
export const getStatusBadgeClass = (status, statusType = 'sale') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : SALE_STATUS_CONFIG;
  return statusConfig[status]?.class || 'badge-custom-default';
};

// Función helper para obtener el label de un estado
export const getStatusLabel = (status, statusType = 'sale') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : SALE_STATUS_CONFIG;
  return statusConfig[status]?.label || status;
};

// Función helper para obtener los colores de un estado
export const getStatusColors = (status, statusType = 'sale') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : SALE_STATUS_CONFIG;
  return statusConfig[status] || {
    backgroundColor: 'var(--rg-color-secondary-lighter)',
    textColor: 'var(--rg-color-secondary-active)'
  };
};
